import { render, staticRenderFns } from "./period-filter.vue?vue&type=template&id=15a981ef&scoped=true&"
import script from "./period-filter.vue?vue&type=script&lang=js&"
export * from "./period-filter.vue?vue&type=script&lang=js&"
import style0 from "./period-filter.vue?vue&type=style&index=0&id=15a981ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a981ef",
  null
  
)

export default component.exports